import React, {
  useState,
  useEffect
} from 'react';
import { InitialLoading } from './src/components/InitialLoading';
import * as SplashScreen from 'expo-splash-screen';
import * as Font from 'expo-font';
import { fonts } from './src/styles/fonts';

import { GlobalContext } from './src/contexts/GlobalContext';
import { AppIndex } from './src/AppIndex';
import { View } from 'react-native';


export default function App() {
  const [appIsReady, setAppIsReady] = useState(false);

  async function prepare() {
    try {
      // Keep the splash screen visible while we fetch resources
      await SplashScreen.preventAutoHideAsync();
      // Pre-load fonts, make any API calls you need to do here
      await Font.loadAsync(fonts);

      await SplashScreen.hideAsync();
      setAppIsReady(true);

    } catch (e) {
      console.warn(e);
    }
  }
  useEffect(() => {
    prepare();
  }, [appIsReady]);
  if (!appIsReady) return <InitialLoading />
  return (
    <View style={{ flex: 1, overflow: 'hidden' }}>

      <GlobalContext>
        <AppIndex />
      </GlobalContext>

    </View>
  );
}